import type { ProductAttributeValue } from '../../services/productApi';

import styles from './utils.module.css';

/**
 * Converts a Record<string, ProductAttributeValue[]> (attributes map) into
 * an array of table rows, grouping multi-value attributes into a single row.
 */
export function groupAttributes(
	attributes: Record<string, ProductAttributeValue[]>,
) {
	const rows: { id: string; label: string; value: string | React.ReactNode }[] =
		[];

	Object.entries(attributes).forEach(([attrName, values], index) => {
		if (values.length > 1) {
			const valueLines = values.map((item, i) => {
				const display = formatAttributeValue(item);
				return (
					<div key={i} className={styles['specification-row']}>
						{display}
					</div>
				);
			});

			rows.push({
				id: `grouped_${attrName}_${index}`,
				label: attrName,
				value: <div>{valueLines}</div>,
			});
		} else if (values.length === 1) {
			rows.push({
				id: `attr_${index}`,
				label: attrName,
				value: formatAttributeValue(values[0]),
			});
		}
	});

	return rows;
}

function formatAttributeValue(attr: ProductAttributeValue): string {
	if (attr.valueType === 'range') {
		const min = attr.minValueText ?? String(attr.minValue ?? '');
		const max = attr.maxValueText ?? String(attr.maxValue ?? '');
		return `${min} – ${max}`;
	}

	return attr.valueText ?? String(attr.value ?? '');
}
